import React, { useState } from "react";

import jsonExport from "jsonexport/dist";
import { fillDownRows } from "../../../utils/exportsUtils";
import { API, graphqlOperation } from "aws-amplify";
import { searchInventorysRecall } from "../../../graphql/report-queries";

import { Card, Grid, TextField as FilterField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import {
  Button,
  DateField,
  downloadCSV,
  ListContextProvider,
  NumberField,
  required,
  SimpleForm,
  TextField,
  Title,
  TopToolbar,
  useList,
  useListContext,
  useNotify,
} from "react-admin";

import { AccountDropDown } from "../../../components/common/AccountDropDown";
import { ExportIcon } from "../../../components/common/iconography";
import { BackButton } from "../../../components/common/BackButton";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { Pagination } from "../../../components/Pagination";
import { logError } from "../../../utils/appUtils";
import CustomizableDatagrid from "../../../components/common/ra-customizable-datagrid";
import { CustomField } from "../../../components/common/CustomFields";
import { exportCustomField } from "../../../utils/utils";
import { handleAccountChange } from "../ReportsUtils";

const useStyles = makeStyles((theme) => ({
  submitButton: {
    position: "absolute",
    bottom: theme.spacing(2),
  },
  totals: {
    marginLeft: theme.spacing(2),
  },
}));

const validateRequired = required();

const exporter = (inventories, searchTerm) => {
  const customHeaderMap = new Map();
  debugger;

  const inventoriesForExport = inventories.map((inventory) => {
    const inventoryForExport = {
      inventoryId: inventory.id,
      productCode: inventory.productCode,
      productName: inventory.productName,
      locationFullName: inventory.locationFullName,
      lotNumber: inventory.lotNumber,
      receivedAt: inventory.receivedAt,
      inventoryUOM: inventory.inventoryUOM,
      status: inventory.status,
      quantityReceived: `${inventory.quantityReceived}`,
      quantityOnHand: `${inventory.quantityOnHand}`,
    };

    if (inventory.customFields?.length > 0) {
      inventory.customFields.forEach((field) => {
        exportCustomField(field, inventoryForExport, customHeaderMap);
      });
    }

    inventoryForExport.inbound = {
      shipmentId: inventory.inboundShipmentId,
      poNumber: inventory.poNumber,
      carTrlNumber: inventory.railCarNumber,
    };

    if (inventory.inboundShipment.customFields?.length > 0) {
      inventory.inboundShipment.customFields.forEach((field) => {
        exportCustomField(field, inventoryForExport.inbound, customHeaderMap);
      });
    }

    if (inventory.shipmentLineItems?.items.length > 0) {
      inventoryForExport.outbound = inventory.shipmentLineItems?.items.map(
        (itm) => {
          debugger;
          const outbound = {
            shipmentId: itm.outboundShipmentId,
            quantityShipped: itm.totalQuantityToPick,
            poNumber: itm.outboundShipment.poNumber,
            pickupNumber: itm.outboundShipment.pickupNumber,
            carTrlNumber: itm.outboundShipment.railCarNumber,
            carrier: itm.outboundShipment.carrierName,
            status: itm.outboundShipment.status,
            shippedDateTime: itm.outboundShipment.departureDateTime,
            "shipTo.name": itm.outboundShipment.shipTo?.name,
            "shipTo.address": itm.outboundShipment.shipTo?.address,
            "shipTo.city": itm.outboundShipment.shipTo?.city,
            "shipTo.state": itm.outboundShipment.shipTo?.state,
            "shipTo.zipCode": itm.outboundShipment.shipTo?.zipCode,
            "shipTo.country": itm.outboundShipment.shipTo?.country,
          };

          if (itm.outboundShipment.customFields?.length > 0) {
            itm.outboundShipment.customFields.forEach((field) => {
              exportCustomField(field, outbound, customHeaderMap);
            });
          }

          return outbound;
        },
      );
    }

    return inventoryForExport;
  });

  jsonExport(
    fillDownRows(inventoriesForExport),
    {
      rename: [
        // "Customer", "Product Code", "Product", "Inventory Qty", "UOM"
      ],
    },
    (err, csv) => {
      downloadCSV(csv, `report_inventory_recall_${searchTerm}`); // download as 'report_inventory_recall_searchTerm.csv` file
    },
  );
};

const ListActions = (props) => {
  const classes = useStyles();

  const {
    finalData,
    setAccountId,
    account,
    setAccount,
    searchTerm,
    setSearchTerm,
    getReportData,
  } = props;

  return (
    <TopToolbar>
      <Grid container direction="row" spacing={1}>
        <Grid item xs={12} md={4}>
          <AccountDropDown
            source="accountId"
            label="Account"
            onAccountChange={(value) =>
              handleAccountChange(value, setAccount, setAccountId)
            }
            validate={validateRequired}
            allowEmpty={false}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <FilterField
            id="search"
            label="Inventory Search"
            variant="outlined"
            margin="dense"
            fullWidth
            alwaysOn
            value={searchTerm}
            onChange={(evt) => setSearchTerm(evt?.target?.value)}
          />
        </Grid>

        <Grid item xs={2}>
          <Button
            label="Run"
            variant="contained"
            color="default"
            alwaysOn
            className={classes.submitButton}
            onClick={getReportData}
            disabled={!account?.id || !searchTerm}
          />
        </Grid>
      </Grid>
      <Button
        label="Export"
        disabled={finalData?.length === 0}
        onClick={() => exporter(finalData, searchTerm)}
      >
        <ExportIcon />
      </Button>
      <BackButton basePath="/reports" />
    </TopToolbar>
  );
};

// /reportInventoryRecall
export const InventoryRecallReport = (props) => {
  const notify = useNotify();

  const [accountId, setAccountId] = useState("");
  const [account, setAccount] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const [finalData, setFinalData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getReportData = async () => {
    try {
      debugger;
      setLoading(true);
      const limit = 1000;
      const searchInput = {
        sort: { field: "receivedAt", direction: "asc" },
        filter: {
          reloadYardId: { eq: window.appUser.reloadYardId },
        },
        limit,
      };
      if (accountId) {
        searchInput.filter.accountId = { eq: `${accountId}` };
      }
      if (searchTerm) {
        searchInput.filter.or = [
          { productCode: { matchPhrasePrefix: `${searchTerm}` } },
          { productCode: { wildcard: `*${searchTerm}*` } },
          { productName: { matchPhrasePrefix: `${searchTerm}` } },
          { productName: { wildcard: `*${searchTerm}*` } },
          { lotNumber: { matchPhrasePrefix: `${searchTerm}` } },
          { lotNumber: { wildcard: `*${searchTerm}*` } },
          { poNumber: { matchPhrasePrefix: `${searchTerm}` } },
          { poNumber: { wildcard: `*${searchTerm}*` } },
          { railCarNumber: { matchPhrasePrefix: `${searchTerm}` } },
          { railCarNumber: { wildcard: `*${searchTerm}*` } },
          { customFields: { matchPhrasePrefix: `${searchTerm}` } },
          { customFields: { wildcard: `*${searchTerm}*` } },
        ];
      }

      let inventorys = [];
      let nextToken = true;
      while (nextToken) {
        const input =
          nextToken === true ? searchInput : { ...searchInput, nextToken };
        const result = await API.graphql(
          graphqlOperation(searchInventorysRecall, input),
        );
        inventorys.splice(-1, 0, ...result.data.searchInventorys.items);
        if (result.data.searchInventorys.items.length < limit) break;
        nextToken = result.data.searchInventorys.nextToken;
      }

      setFinalData(inventorys);
    } catch (err) {
      logError("InventoryRecallReport:getReportData", err, notify);
      setFinalData([]);
    } finally {
      setLoading(false);
    }
  };

  const fixedFilter = ""; // {"lowInventoryAlert": true};
  const defaultSort = { field: "receivedAt", order: "ASC" };
  const defaultPerPage = 25;

  const listContext = useList({
    ...props,
    data: finalData,
    ids: finalData.map(({ id }) => id),
    loading,
    loaded: !loading,
    filter: fixedFilter,
    sort: defaultSort,
    perPage: defaultPerPage,
  });

  return (
    <SimpleForm toolbar={false}>
      <ListContextProvider value={listContext}>
        <Title title={<ForceTitle title="Inventory Recall Report" />} />
        <ListActions
          {...props}
          finalData={finalData}
          setAccountId={setAccountId}
          account={account}
          setAccount={setAccount}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          getReportData={getReportData}
        />
        <Card>
          <ReportGrid account={account} />
          <Pagination {...props} {...listContext} />
        </Card>
      </ListContextProvider>
    </SimpleForm>
  );
};

const ReportGrid = ({ account, ...props }) => {
  const listContext = useListContext(props);
  const accountFields =
    account?.inventoryCustomFields?.length > 0
      ? account.inventoryCustomFields
      : [];
  const customGridFields = accountFields
    ? accountFields.map((field, index) => {
        return (
          <CustomField
            source={`customFields[${index}]`}
            field={field}
            label={field.name}
            sortable={true}
          />
        );
      })
    : [];

  if (!account?.id) return null;
  return (
    <CustomizableDatagrid
      {...listContext}
      rowClick={false}
      hasBulkActions={false}
      storageProp={`InventoryStorageReport_${account?.id}_large`}
      defaultColumns={[
        "productCode",
        "productName",
        "poNumber",
        "receivedAt",
        "railCarNumber",
        "quantityOnHand",
      ]}
    >
      {[
        <TextField source="productCode" label="Product Code" />,
        <TextField source="productName" label="Product Name" />,
        <DateField source="receivedAt" label="Received" showTime={false} />,
        <TextField source="poNumber" label="PO Number" />,
        <TextField source="railCarNumber" label="Car/Trl No." />,
        <NumberField source="quantityOnHand" label="Qty. OnHand" />,
        <TextField source="inventoryUOM" label="UOM" />,
        ...customGridFields,
      ]}
    </CustomizableDatagrid>
  );
};
